module.exports = __webpack_public_path__ + "img/img5.ad07a086.jpg";